"use client"

import { motion, AnimatePresence } from "framer-motion"
import { LogoLoader } from "@/shared/ui/logo-loader"
import { useKesiapanHalaman } from "@/shared/hooks/use-kesiapan-halaman"
import { awalKataKapital } from "@/shared/lib/format-nama"

interface LoadingScreenProps {
  ownerName: string
}

export function LoadingScreen({ ownerName }: LoadingScreenProps) {
  const siap = useKesiapanHalaman()

  return (
    <AnimatePresence>
      {!siap && (
        <motion.div
          key="loading-screen"
          role="status"
          aria-live="polite"
          aria-label="Memuat halaman"
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-background"
        >
          <LogoLoader size={128} durasiDetik={1.7} />

          {ownerName && (
            <p className="absolute bottom-10 text-center text-[10px] tracking-[0.3em] text-muted-foreground uppercase font-semibold opacity-80">
              by {awalKataKapital(ownerName)}
            </p>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  )
}
